export default __webpack_public_path__ + "static/media/research-compute.7af71978.jpg";